import {
  ClearButtonBehaviour,
  NumericInput,
  NumericInputProps,
} from '@infotech-soe/erp-ui-kit';
import React from 'react';

import { NumericInputFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';

import { TFormControlConnectorProps } from './FormControlContainer';
import FormLabeledInputControl from './FormLabeledInputControl';
import FormTextControl from './hoc/FormTextControl';
import { RequiredHistoryProps, withHistory } from './hoc/HistoryContainer';
import UpdaterButton from './UpdaterButton';

interface Props
  extends
    RequiredHistoryProps<HTMLInputElement>,
    Pick<TFormControlConnectorProps, 'areHintsShown' | 'onRunSingleUpdater'>,
    Pick<
      NumericInputProps,
      | 'className'
      | 'keymap'
      | 'onChange'
      | 'onChanged'
      | 'onSubmit'
      | 'onValidate'
    > {
  control: NumericInputFormControlViewModel;
  value: number | null;
}

const FormNumericInputControl: React.FC<Props> = ({
  areHintsShown,
  className,
  control,
  keymap,
  onRef,
  rounded,
  value,
  onChange,
  onChanged,
  onRunSingleUpdater,
  onSubmit,
  onValidate,
}) => (
  <FormLabeledInputControl areHintsShown={areHintsShown} control={control}>
    <NumericInput
      className={className}
      containerRef={onRef}
      disabled={control.disabled}
      initialStepValue={control.initialStepValue}
      invalid={control.invalid}
      keymap={keymap}
      max={control.max}
      min={control.min}
      name={control.name}
      onChange={onChange}
      onChanged={onChanged}
      onSubmit={onSubmit}
      onValidate={onValidate}
      precision={control.precision}
      readOnly={control.readonly}
      required={control.required}
      rounded={rounded}
      step={control.step}
      value={value}
      withClearButton={ClearButtonBehaviour.BOTH}
      withoutThousandSeparator={control.withoutThousandSeparator}
      endSlot={
        control.updater ? (
          <UpdaterButton control={control} updater={onRunSingleUpdater} />
        ) : undefined
      }
    />
  </FormLabeledInputControl>
);

export default withHistory(FormTextControl(FormNumericInputControl));
